import { Component, h, Prop } from '@stencil/core'
import { Fragment } from '@stencil/core/internal'
import { toNumber } from 'lodash-es'

import { ICrmOpportunity } from '../../../../call/types'
import { formatNumber } from '../../../../utils/number'
import { ExternalLink } from '../../../../utils/url'

@Component({ tag: 'page-call-detail-crm-opportunity' })
export class Opportunity {
  @Prop() opportunity: ICrmOpportunity

  render() {
    const content = (
      <Fragment>
        <ui-icon size='3xl' class='text-info-warn' icon='currency-exchange'></ui-icon>
        <dl class='flex flex-col flex-grow pl-1'>
          <dt class='font-bold'>{this.opportunity.name || this.opportunity.external_id}</dt>
          <dd class='text-xs text-glyph-lighter'>
            {this.opportunity.stage && <span class='font-extrabold text-info-ok'>{this.opportunity.stage}</span>}
            {this.opportunity.dollar_value && toNumber(this.opportunity.dollar_value) > 0 && (
              <span class='font-medium'>
                {this.opportunity.stage && <Fragment>&nbsp;&bull;&nbsp;</Fragment>}$
                {formatNumber(this.opportunity.dollar_value)}
              </span>
            )}
          </dd>
        </dl>
        <div class='flex items-center p-0 m-0 text-lg text-glyph-lighter spacing-x-2'>
          <page-call-detail-crm-status provider={this.opportunity.provider} />
        </div>
      </Fragment>
    )

    if (this.opportunity.deal_page_url) {
      return (
        <a class='flex items-center text-md tracking-tight truncate spacing-x-1' href={this.opportunity.deal_page_url}>
          {content}
        </a>
      )
    }

    return (
      <ExternalLink href={this.opportunity.url} class='flex items-center text-md tracking-tight truncate spacing-x-1'>
        {content}
      </ExternalLink>
    )
  }
}
